import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import { InfoCircle } from "iconsax-react";
import ReactSelect from "react-select";
import { DownArrowAction, ExportIcon, Plus, Search } from "../../assets/svg";
import { InputError } from "../error/error";
import {
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import {
  DateRangeIcon,
  LocalizationProvider,
  MobileDatePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export const Icon = ({ iconName, size, color }) => {
  const IconName = require(`iconsax-react`)[iconName];
  return <IconName size={size} color={color} />;
};
export const StartDateOfMonth = () => {
  var currentDate = new Date();
  const startDateOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  return startDateOfMonth;
};
export const DefaultPhoneInput = ({
  value,
  onChange,
  defaultCountry = "IN",
  ...res
}) => {
  return (
    <PhoneInput
      international
      countryCallingCodeEditable={false}
      defaultCountry={defaultCountry}
      value={value}
      onChange={onChange}
      {...res}
    />
  );
};
export const Input = ({ className, ...res }) => {
  return <input className={className} {...res} />;
};
export const Badge = ({ className, value, ...res }) => {
  return (
    <p
      className={`border rounded-full px-3 py-2 text-[13px] font-normal text-center font-Proxima  ${className}`}
      {...res}
    >
      {value}
    </p>
  );
};

export const AddButton = ({ className, value, ...res }) => {
  return (
    <div className={`flex justify-center py-3 ${className}`}>
      <button
        className="bg-themeBtn text-sm font-normal text-white flex items-center justify-center px-4 py-2.5 rounded uppercase font-Proxima shadow-[0_4px_6px_rgba(0,0,0,0.3)]"
        type="button"
        {...res}
      >
        <Plus className="fill-white mr-2" />
        <p>{value}</p>
      </button>
    </div>
  );
};

export const PrimaryButton = ({ className, value, ...res }) => {
  return (
    <div className={`flex justify-center py-3 ${className}`}>
      <button
        className="bg-themeBtn text-white flex items-center justify-center px-4 py-2.5 rounded uppercase font-Proxima "
        type="button"
        {...res}
      >
        <p>{value}</p>
      </button>
    </div>
  );
};

export const PrimaryCancelButton = ({ className, value, ...res }) => {
  return (
    <div className={`flex justify-center py-3 ${className}`}>
      <button
        className="bg-white text-themeBtn border border-themeBtn flex items-center justify-center px-4 py-2.5 rounded uppercase font-Proxima "
        type="button"
        {...res}
      >
        <p>{value}</p>
      </button>
    </div>
  );
};

export const DropdownAddButton = ({
  className,
  value,
  options = [],
  onClick,
  ...res
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = (option) => {
    setIsOpen(false);
    if (onClick) {
      onClick(option);
    }
  };
  return (
    <div className={`flex justify-center py-3 relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-themeBtn text-white flex items-center justify-center px-4 py-2.5 rounded uppercase font-Proxima shadow-[0_4px_6px_rgba(0,0,0,0.3)]"
        type="button"
        {...res}
      >
        <Plus className="fill-white mr-2" />
        <p>{value}</p>
      </button>
      {isOpen && options.length > 0 && (
        <ul className="absolute top-12 left-0 bg-bgWhite mt-2 shadow-lg z-10 right-0 w-[190px] rounded">
          {options.map((option, index) => (
            <li
              key={index}
              className="px-4 py-2 hover:bg-hoverTheme cursor-pointer font-Proxima"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
export const DropdownAction = ({
  className,
  value,
  options = [],
  onClick,
  ...res
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = (option) => {
    setIsOpen(false);
    if (onClick) {
      onClick(option);
    }
  };
  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-themeBtn flex items-center font-Proxima justify-center px-6 py-2 rounded border border-themeBtn uppercase"
        type="button"
        {...res}
      >
        <p>{value}</p>
        <DownArrowAction className="fill-themeBtn ml-2" />
      </button>
      {isOpen && options.length > 0 && (
        <ul className="absolute bg-bgWhite mt-2 shadow-lg z-10 right-0 w-[190px] rounded">
          {options.map((option, index) => (
            <li
              key={index}
              className="px-4 py-2 hover:bg-hoverTheme cursor-pointer"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
export const AddPrimaryButton = ({
  className,
  value,
  height,
  width,
  ...res
}) => {
  return (
    <div className={`flex justify-center ${className}`}>
      <button
        className={` text-themeBtn flex items-center justify-center px-6 py-2.5 rounded border border-themeBtn`}
        type="button"
        {...res}
        style={{ height, width }}
      >
        <Plus className="fill-themeBtn mr-2" />
        <p>{value}</p>
      </button>
    </div>
  );
};
export const ExportButton = ({ className, value, height, width, ...res }) => {
  return (
    <div className={`flex justify-center ${className}`}>
      <button
        className={` text-themeBtn flex items-center justify-center px-6 py-2 rounded border border-themeBtn`}
        type="button"
        {...res}
        style={{ height, width }}
      >
        <ExportIcon className="fill-themeBtn mr-2" />
        <p className="pl-2 font-Proxima font-normal text-[15px]">{value}</p>
      </button>
    </div>
  );
};
export const DefaultButton = ({ className, type, value, disabled, ...res }) => {
  return (
    <div className={`flex justify-center py-2 ${className}`}>
      <button
        className={`${
          disabled
            ? "bg-mGray cursor-not-allowed text-borderGrey"
            : "bg-themeBtn"
        }  text-bgWhite flex items-center justify-center px-6 py-2.5 rounded uppercase font-Proxima`}
        type={type ?? "button"}
        disabled={!!disabled}
        {...res}
      >
        <p className="font-Proxima font-normal text-[15px]">{value}</p>
      </button>
    </div>
  );
};

export const DefaultPrimaryButton = ({
  className,
  value,
  height,
  width,
  onClick,
  ...res
}) => {
  return (
    <div className={`flex justify-center py-2 ${className}`}>
      <button
        className={` text-themeBtn flex items-center justify-center px-6 py-2 rounded border border-themeBtn font-Proxima`}
        type="button"
        {...res}
        style={{ height, width }}
        onClick={onClick}
      >
        <p className="font-Proxima text-[15px] uppercase">{value}</p>
      </button>
    </div>
  );
};
export const SearchInput = ({
  value,
  onChange,
  placeholder,
  errors,
  errorsText,
  inputClass,
  className = "",
  ...res
}) => {
  return (
    <div className={`${className} relative flex items-center`}>
      <span className="absolute left-3 top-1/2 transform -translate-y-1/2">
        <Search />
      </span>
      <Input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`pl-10 pr-3 py-2 w-full text-sm bg-white rounded border border-grey focus:outline-none  ${inputClass}`}
        {...res}
      />

      {errors && <InputError errorTitle={errorsText} />}
    </div>
  );
};

export const InputWithLabel = ({
  className,
  idFromName,
  label,
  type = "text",
  errors,
  inputClass,
  errorsText,
  disabled,
  icon,
  rows,
  ...res
}) => {
  return (
    <div>
      <div
        className={`${className} relative bg-white transition duration-300 rounded`}
      >
        {type === "textarea" ? (
          <textarea
            id={idFromName}
            name={idFromName}
            disabled={disabled}
            rows={rows}
            className={`block px-2.5 pb-2.5 pt-4 w-full text-sm error-forms bg-transparent rounded 
              border-borderTheme/80 appearance-none focus:outline-none focus:ring-0 peer h-12 ${inputClass}`}
            placeholder={" "}
            {...res}
          />
        ) : (
          <Input
            type={type}
            id={idFromName}
            disabled={disabled}
            name={idFromName}
            className={`block px-2.5 py-2 w-full text-sm error-forms bg-transparent rounded 
              border-borderTheme/80 appearance-none focus:outline-none focus:ring-0 peer ${inputClass}`}
            placeholder={" "}
            {...res}
          />
        )}
        <label
          htmlFor={idFromName}
          className="absolute text-textGrey pointer-events-none text-base bg-white duration-300 transform -translate-y-5 scale-75 top-2 origin-[0] px-2 peer-focus:px-2 peer-focus peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 left-1 font-Proxima"
        >
          {label}
        </label>
        {icon && <>{icon}</>}
      </div>
      {errors ? <InputError errorTitle={errorsText} /> : null}
    </div>
  );
};

export const TextareaWithLabel = ({
  className,
  idFromName,
  label,
  errors,
  errorsText,
  inputClass,
  icon,
  ...res
}) => {
  return (
    <div>
      <div
        className={`${className} relative bg-white border-secondary_grey transition duration-300 rounded`}
      >
        <textarea
          id={idFromName}
          name={idFromName}
          className={`block px-2.5 pb-2.5 pt-4 w-full text-sm error-forms text-gray-900 bg-transparent rounded border-1 appearance-none focus:outline-none focus:ring-0 focus:border-themeBtn peer ${inputClass}`}
          placeholder={" "}
          {...res}
        ></textarea>
        <label
          htmlFor={idFromName}
          className="absolute text-light_grey border-gray pointer-events-none text-base bg-white duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[0] px-2 peer-focus:px-2 peer-focus peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-full peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 left-1"
        >
          {label}
        </label>
      </div>
      {errors ? <InputError errorTitle={errorsText} /> : null}
    </div>
  );
};
export const RadioButton = ({
  className,
  idFrom,
  name,
  value,
  label,
  ...res
}) => {
  return (
    <label
      htmlFor={idFrom}
      className={`flex items-center space-x-2 ${className}`}
    >
      <input
        type="radio"
        name={name}
        value={value}
        id={idFrom}
        className="w-0 h-0 peer hidden"
        {...res}
      />
      <span className="w-5 h-5 border-2 inline-block border-textSecondary rounded-full peer-checked:border-themeBtn relative peer-checked:after:absolute peer-checked:after:top-1/2 peer-checked:after:left-1/2 peer-checked:after:rounded-full peer-checked:after:w-3 peer-checked:after:h-3 peer-checked:after:bg-themeBtn peer-checked:after:-translate-x-1/2 peer-checked:after:-translate-y-1/2"></span>
      <p className="font-Proxima text-base text-mgrey font-normal">{label}</p>
    </label>
  );
};
export const InformationTag = ({ type, text, size, ...res }) => {
  return (
    <div
      className={`flex items-center ${
        type === "success"
          ? "text-success bg-green-100"
          : type === "error"
          ? "text-red bg-red-100"
          : ""
      } space-x-3 rounded px-5 py-3`}
      {...res}
    >
      <InfoCircle size={size} />
      <span className="font-normal">{text}</span>
    </div>
  );
};

export const CheckBox = ({
  className,
  idFrom,
  name,
  label,
  labelClass,
  ...res
}) => {
  return (
    <label
      htmlFor={idFrom}
      className={`flex items-center space-x-2 ${className}`}
    >
      <input
        type="checkbox"
        name={name}
        id={idFrom}
        className="w-0 h-0 peer"
        {...res}
      />
      <span
        className={`max-w-5 w-full h-5 border-2 border-secondary_grey inline-block rounded peer-checked:border-theme relative peer-checked:after:absolute peer-checked:after:top-1/2 peer-checked:after:left-1/2  peer-checked:after:w-full peer-checked:after:h-[calc(100%+3px)] peer-checked:after:bg-check_img peer-checked:after:-translate-x-1/2 peer-checked:after:-translate-y-1/2`}
      ></span>
      <p className={labelClass}>{label}</p>
    </label>
  );
};
export const Tooltip = ({
  tooltipLabel,
  label,
  labelClass,
  tooltipLabelClass,
  isLeft,
  ...res
}) => {
  return (
    <div className="relative group" {...res}>
      <button className={labelClass}>{label}</button>

      <div
        className={`absolute ${
          isLeft
            ? "right-full top-1/2 transform -translate-y-1/2 -translate-x-5 -mr-2"
            : "bottom-full left-1/2 transform -translate-x-1/2 mb-2"
        } hidden group-hover:block bg-navTheme text-white text-xs px-4 py-2 rounded ${tooltipLabelClass}`}
      >
        {tooltipLabel}
        <div
          className={`absolute ${
            isLeft
              ? "top-1/2 left-full transform -translate-y-1/2  border-l-8 border-l-navTheme border-t-8 border-t-transparent border-b-8 border-b-transparent"
              : "top-full left-1/2 transform -translate-x-1/2 border-t-8 border-t-navTheme border-l-8 border-l-transparent border-r-8 border-r-transparent"
          } w-0 h-0`}
        ></div>
      </div>
    </div>
  );
};

export const TooltipDetail = ({
  tooltipLabel,
  tooltipLabelClass = "",
  isLeft = false,
  children,
  ...res
}) => {
  return (
    <div className="relative group inline-block w-full" {...res}>
      {children}

      <div
        className={`absolute z-50 pointer-events-none
          ${
            isLeft
              ? "right-full top-1/2 transform -translate-y-1/2 -translate-x-2"
              : "bottom-full left-1/2 transform -translate-x-1/2 mb-2"
          }
          hidden group-hover:block bg-navTheme text-white text-xs px-4 py-2 rounded shadow-lg
          ${tooltipLabelClass}
        `}
      >
        {tooltipLabel}
        <div
          className={`absolute ${
            isLeft
              ? "top-1/2 left-full transform -translate-y-1/2  border-l-8 border-l-navTheme border-t-8 border-t-transparent border-b-8 border-b-transparent"
              : "top-full left-1/2 transform -translate-x-1/2 border-t-8 border-t-navTheme border-l-8 border-l-transparent border-r-8 border-r-transparent"
          } w-0 h-0`}
        ></div>
      </div>
    </div>
  );
};

export const SelectBox = ({
  options,
  placeholder,
  errors,
  errorsText,
  className,
  disabled,
  ...res
}) => {
  return (
    <div>
      <ReactSelect
        className={`text-black p-0 font-Proxima ${className}`}
        placeholder={placeholder}
        options={options}
        isClearable={true}
        isSearchable={false}
        isDisabled={disabled}
        {...res}
        styles={{
          control: (base) => ({
            ...base,
            border: disabled
              ? "1px solid #D3D3D3 border-dashed border"
              : errors
              ? "1px solid red"
              : "1px solid #0000003B",
            backgroundColor: "white",
            borderRadius: "0.25rem",
            boxShadow: "none",
            "&:hover": {
              border: disabled ? "1px solid #D3D3D3" : "1px solid #0000003B",
            },
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#F15B29" : "white",
            "&:active": {
              backgroundColor: state.isSelected
                ? "#F15B29"
                : "rgba(0, 0, 0, 0.04)",
            },
          }),
          menu: (base) => ({
            ...base,
            zIndex: 1000,
          }),
        }}
      />
      {errors && <InputError errorTitle={errorsText} />}
    </div>
  );
};

export const SelectWithLabel = ({
  idFromName,
  placeholder,
  errors,
  touched,
  options,
  value,
  setFieldValue,
  className,
  onChange,
  disabled,
  multiple,
  renderValue,
  input,
  endAdornment,
  fontSize = "16px",
  helperText,
  sx: customSx,
  ...res
}) => {
  return (
    <div>
      <FormControl fullWidth size="small" className={className}>
        <InputLabel id={`${idFromName}-label`}>{placeholder}</InputLabel>
        <Select
          id={idFromName}
          value={value}
          label={placeholder}
          input={input}
          renderValue={renderValue}
          color="warning"
          endAdornment={endAdornment}
          multiple={multiple}
          onChange={onChange}
          disabled={disabled}
          {...res}
          className="font-Proxima"
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: "300px",
                overflowY: "auto",
                maxWidth: "100%",
                "& .MuiMenuItem-root": {
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.08)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(241, 91, 41, 0.12)",
                  },
                },
              },
            },
          }}
          sx={{
            "& .MuiSelect-select": {
              fontSize: fontSize,
              fontFamily: "proxima_nova",
            },
            "& .MuiInputBase-input": {
              fontSize: fontSize,
            },
            ...(disabled && {
              border: "1px dashed #ccc",
              borderRadius: "4px",
            }),
            ...customSx,
          }}
          InputLabelProps={{
            sx: {
              "&.Mui-focused": {
                color: "#f15b29",
              },
            },
          }}
        >
          {options?.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              className="font-Proxima text-base"
            >
              {option?.label}
            </MenuItem>
          ))}
        </Select>
        {errors && touched ? <InputError errorTitle={errors} /> : null}
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </div>
  );
};

export const DatePicker = ({
  id,
  value,
  onChange,
  label,
  error,
  touched,
  disabled = false,
  name,
  maxDate,
  icon = <DateRangeIcon />,
  ...props
}) => {
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <MobileDatePicker
          id={id}
          value={value}
          label={label}
          onChange={onChange}
          disabled={disabled}
          format="DD/MM/YYYY"
          maxDate={maxDate}
          slotProps={{
            textField: {
              size: "small",
              variant: "outlined",
              label,
              fullWidth: true,
              color: "warning",
              error: Boolean(error && touched),
              sx: {
                "& .MuiOutlinedInput-root": {
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#F15B29",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#F15B29",
                    borderWidth: "1px",
                  },
                },
              },
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">{icon}</InputAdornment>
                ),
              },
            },
            actionBar: {
              sx: {
                "& .MuiButton-root": {
                  color: "#F15B29",
                },
                "& .MuiButton-root.Mui-cancelButton": {
                  color: "gray",
                },
              },
            },
            day: {
              sx: {
                "&.MuiPickersDay-root.Mui-selected": {
                  backgroundColor: "#F15B29",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "#F15B29",
                  },
                },
              },
            },
          }}
          InputLabelProps={{
            shrink: true,
            sx: {
              "&.Mui-focused": {
                color: "red !important",
              },
              "&.MuiInputLabel-shrink": {
                color: "red !important",
              },
            },
          }}
          {...props}
        />
      </LocalizationProvider>

      {error && touched && <InputError errorTitle={error} />}
    </div>
  );
};
